var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6097 18.9905L13.5297 9.91046C14.4597 7.57046 13.9797 4.81046 12.0897 2.91046C9.78972 0.61046 6.20972 0.400459 3.65972 2.26046L7.49972 6.11046L6.07972 7.52046L2.24972 3.69046C0.389717 6.23046 0.599717 9.82046 2.89972 12.1105C4.75972 13.9705 7.46972 14.4605 9.78972 13.5905L18.8997 22.7005C19.2897 23.0905 19.9197 23.0905 20.3097 22.7005L22.6097 20.4005C23.0097 20.0205 23.0097 19.3905 22.6097 18.9905ZM19.6097 20.5905L10.1497 11.1305C9.53972 11.5805 8.85972 11.8505 8.14972 11.9505C6.78972 12.1505 5.35972 11.7405 4.31972 10.7005C3.36972 9.76046 2.92972 8.50046 2.99972 7.26046L6.08972 10.3505L10.3297 6.11046L7.23972 3.02046C8.47972 2.95046 9.72972 3.39046 10.6797 4.33046C11.7597 5.41046 12.1697 6.90046 11.9197 8.29046C11.7997 9.00046 11.4997 9.66046 11.0397 10.2505L20.4897 19.7005L19.6097 20.5905Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/wrench.3b7e052c.svg";
export { ForwardRef as ReactComponent };